<template>
  <div>
    <el-form
      ref="commonUpload"
      :model="ruleForm"
      :rules="rules"
      label-width="200px"
      label-suffix="："
      class="demo-ruleForm"
    >
      <el-row>

        <el-form-item label="品类" :required="!isDetail" prop="categoryId">
          <div v-if="isDetail">{{ allCategoryValue }}</div>
          <div v-else>
              <!--是电仪 :disabled="handleDisable"-->
            <div v-if="handleDisable">
              <el-col :span="4">
                <el-form-item prop="oneCategoryValue">
                  <el-select
                          :key="ruleForm.oneCategoryValue"
                          v-model="ruleForm.oneCategoryValue"
                          filterable
                          placeholder="一级类目"
                          @change="changeOneCategory"
                  >
                    <el-option
                            v-for="item in oneCategory"
                            :key="item.categoryId"
                            :label="item.categoryName"
                            :value="item.categoryId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="twoCategoryValue">
                  <el-select
                          :key="ruleForm.twoCategoryValue"
                          v-model="ruleForm.twoCategoryValue"
                          filterable
                          placeholder="二级类目"
                          @change="changeTwoCategory"
                  >
                    <el-option
                            v-for="item in twoCategory"
                            :key="item.categoryId"
                            :label="item.categoryName"
                            :value="item.categoryId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="threeCategoryValue">
                  <el-select
                          v-model="ruleForm.threeCategoryValue"
                          filterable
                          placeholder="三级类目"
                          @change="(val) => changeThreeCategory(val, 'change')"
                  >
                    <el-option
                            v-for="item in threeCategory"
                            :key="item.categoryId"
                            :label="item.categoryName"
                            :value="item.categoryId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item v-if="fourCategory.length > 0" prop="categoryId">
                  <el-select
                          v-model="ruleForm.categoryId"
                          placeholder="四级类目"
                          filterable
                          @change="(val) => changeFourCategory(val, 'change')"
                  >
                    <el-option
                            v-for="item in fourCategory"
                            :key="item.categoryId"
                            :label="item.categoryName"
                            :value="item.categoryId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
            <!--非电仪-->
            <div v-else>
              <el-col :span="13" class="margin-r10">
                <el-form-item>
                  <el-select
                          v-model="tempData.categoryNameAl"
                          style="width: 100%"
                          filterable
                          remote
                          reserve-keyword
                          :remote-method="handleRemoteMethod"
                          :loading="categoryLoading"
                          value-key="categoryId"
                          clearable
                          placeholder="请输入分类名称"
                          @change="handleSelectChange"
                  >
                    <el-option
                            v-for="item in selectCategoryList"
                            :key="item.categoryId"
                            :label="item.labelName"
                            :value="item"
                    >
                      <span v-html="showHighlight(item.labelName)"/>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
          </div>
          <eui-tooltip
                  v-if="!isDetail"
                  content="请准确选择原材料或零部件的产品目录"
                  placement="top"
                  fontSize="20px"
                  style="margin-top: 6px"
          >
          </eui-tooltip>
        </el-form-item>

        <el-col :span="24">
          <el-form-item label="采购合同及发票上传" prop="contractAttachList">
            <div>
              <div>
                <eui-btn
                  v-if="!isOnlyView"
                  icon="eicon-upload"
                  icon-position="left"
                  type="secondary"
                  @click="handleContractFile('upload')"
                  >上传附件
                </eui-btn>
                <eui-btn
                  v-if="ruleForm.contractAttachList.length > 0"
                  type="text"
                  @click="handleContractFile('view')"
                  >查看附件
                </eui-btn>
              </div>
              <div v-if="!isDetail && !isOnlyView" class="tip-word">
                请上传采购合同、采购发票，最多上传5个附件，格式不限，每个附件大小不超过200M
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="质量文件上传" prop="attachList">
            <div>
              <div>
                <eui-btn
                  v-if="ruleForm.aiCheckResult !== '分析中' && !isOnlyView"
                  icon="eicon-upload"
                  icon-position="left"
                  type="secondary"
                  @click="handleUpload('upload')"
                  >上传附件
                </eui-btn>
                <eui-btn
                  v-if="ruleForm.attachList.length > 0"
                  type="text"
                  @click="handleUpload('view')"
                  >查看附件
                </eui-btn>
              </div>
              <div
                v-if="ruleForm.aiCheckResult !== '分析中' && !isOnlyView"
                class="tip-word"
              >
                附件格式不限，每个附件大小不超过200M
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否进口原材料" prop="imported">
            <el-radio-group v-model="ruleForm.imported" :disabled="isDetail">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
            <div>
              <eui-btn
                v-if="ruleForm.imported !== 0 && !isOnlyView"
                icon="eicon-upload"
                icon-position="left"
                type="secondary"
                @click="handleImportMaterial('upload')"
                >上传附件
              </eui-btn>
              <eui-btn
                v-if="
                  ruleForm.imported !== 0 &&
                  ruleForm.importedAttachList.length > 0
                "
                type="text"
                @click="handleImportMaterial('view')"
                >查看附件
              </eui-btn>

              <div v-if="ruleForm.imported !== 0" class="tip-word">
                请上传过程控制报告、原厂授权书、原始报关单，格式不限，每个附件大小不超过200M
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col v-if="ruleForm.aiCheckResult" :span="24">
          <el-form-item label="AI审查建议结果">
            <div class="check-result">
              <div
                      :class="{
                  'color-red': ruleForm.aiCheckResult === '审查不通过',
                }"
                      @click="showCheckResult(ruleForm.requestId, ruleForm.aiCheckResult)"
              >
                {{ ruleForm.aiCheckResult }}
              </div>
              <eui-tooltip
                style="margin-left: 10px"
                :content="aiCheckResultTip"
                placement="top"
              >
                <eui-icon
                  icon="eicon-r-changjianwenti"
                  font-size="14px"
                  color="#666666"
                />
              </eui-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!--采购合同上传-->
    <contract-upload
            v-if="contractUploadVisible"
            :contractUploadVisible.sync="contractUploadVisible"
            :handle-flag="handleFlag"
            :categoryCode="ruleForm.categoryCode"
            :view-contract-attach-data="viewContractAttachData"
            @dealContractAttachData="dealContractAttachData"
    />
    <!--附件上传-->
    <attachment-upload
            v-if="attachmentUploadVisible"
            :attachmentUploadVisible.sync="attachmentUploadVisible"
            :category-code="ruleForm.categoryCode"
            :handle-flag="handleFlag"
            :view-table-data="viewTableData"
            @dealAttachmentFileData="dealAttachmentFileData"
    />
    <!--进口原材料上传-->
    <importMaterialUpload
      v-if="importMaterialUploadVisible"
      :importMaterialUploadVisible.sync="importMaterialUploadVisible"
      :handle-flag="handleFlag"
      :view-contract-attach-data="viewImportMaterialAttachData"
      @dealImportMaterialAttachData="dealImportMaterialAttachData"
    />
    <!--AI审查建议结果-->
    <!--type:1:sku;2:库存单;3:采购意向单成品现货；4：石化商城成品现货-->
    <AIDataReport
      v-if="dataReportVisible"
      :dataReportVisible.sync="dataReportVisible"
      :type="aiAuditType"
      :target-id="targetId"
    />
  </div>
</template>

<script>
import api from '@/modules/projectA/api/order';
import productApi from '@/modules/projectA/api/product';
import userApi from '@/modules/projectA/api/user';
import attachmentUpload from '../../../components/common/attachmentUpload';
import contractUpload from '../../../components/common/contractUpload';
import AIDataReport from '../../../components/common/AIDataReport';
import {epecMallUrl} from '@/modules/projectA/api/config';
// 进口原材料上传
import importMaterialUpload from '../../../components/common/importMaterialUpload';

export default {
  name: 'CommonUpload',
  components: {
    attachmentUpload,
    contractUpload,
    AIDataReport,
    importMaterialUpload,
  },
  props: {
    isDetail: {
      type: Boolean,
      default: false,
    },
    // 只能查看
    isOnlyView: {
      type: Boolean,
      default: false,
    },
    aiAuditType: {
      type: Number,
      default: 1,
    },
    formData: Object,
    supplierCompanyId: Number,
    // targetId: Number,
  },
  data() {
    const validateImportedMaterial = (rule, value, callback) => {
      if (value === 1) {
        if (this.ruleForm.importedAttachList.length === 0) {
          callback(new Error('请上传进口原材料附件'));
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      dataReportVisible: false,
      handleDisable: false,
      disableFirstLevel: true,
      disableSecondLevel: true,

      rules: {
        oneCategoryValue: [
          {
            required: true,
            message: '请选择一级类目',
            trigger: ['blur', 'change'],
          },
        ],
        twoCategoryValue: [
          {
            required: true,
            message: '请选择二级类目',
            trigger: ['blur', 'change'],
          },
        ],
        threeCategoryValue: [
          {
            required: true,
            message: '请选择三级类目',
            trigger: ['blur', 'change'],
          },
        ],
        categoryId: [
          {
            required: true,
            message: '请选择分类名称',
            trigger: ['blur', 'change'],
          },
        ],
        contractAttachList: [
          {
            required: false,
            message: '请上传采购合同',
            trigger: ['blur', 'change'],
          },
        ],
        attachList: [
          {
            required: false,
            message: '请上传附件',
            trigger: ['blur', 'change'],
          },
        ],
        imported: [
          {
            validator: validateImportedMaterial,
            trigger: ['blur', 'change'],
          },
        ],
      },
      allCategoryValue: '',
      ruleForm: {
        contractAttachList: [], // 采购合同
        attachList: [], // 审查附件
        importedAttachList: [], // 进口原材料附件
        oneCategoryValue: '',
        twoCategoryValue: '',
        threeCategoryValue: '',
        // lbbm: '',
        categoryId: '',

        aiCheckResult: '',
        imported: 0,
      },

      oneCategory: [],
      twoCategory: [],
      threeCategory: [],
      fourCategory: [],

      thirdCategoryId: '', // 备用，方便赋值

      contractUploadVisible: false,
      viewContractAttachData: [],
      importMaterialUploadVisible: false,
      viewImportMaterialAttachData: [],
      attachmentUploadVisible: false,
      handleFlag: '',
      isLeaf: 0,
      aiCheckFileList: [],
      attachmentUploadTableData: [], // 用于查看
      viewTableData: [],
      targetId: '',
      aiCheckResultTip:
        'AI审查建议结果仅作为业务处理的参考依据，不会中断或者阻止正常业务流程。',

      itemCategoryCode: '',
      categoryLoading: false,
      timer: null,
      selectCategoryList: [],
      tempData: {
        categoryNameAl: '',
        categoryLevel: 0,
      },
    };
  },
  watch: {
    formData: {
      immediate: true,
      deep: true,
      async handler(newVal) {
        const {
          contractAttachList,
          attachList,
          aiCheckResult,
          categoryId,
          importedAttachList,
          imported,
          requestId,
          // lbbm,
        } = this.formData;
        this.ruleForm.contractAttachList = contractAttachList || [];
        this.ruleForm.attachList = attachList || [];
        this.ruleForm.aiCheckResult = aiCheckResult || '';
        this.ruleForm.importedAttachList = importedAttachList || [];
        this.ruleForm.imported = imported || 0;
        this.ruleForm.requestId = requestId || '';
        // this.ruleForm.lbbm = lbbm;
        this.viewTableData = this.ruleForm.attachList;

        if (categoryId) {
          //编辑得时候不用 固定值
          this.disableFirstLevel = false;
          this.disableSecondLevel = false;
          this.selectCategoryRouteByCategoryId();
        } else {
          this.ruleForm.oneCategoryValue = '';
          this.ruleForm.twoCategoryValue = '';
          this.ruleForm.threeCategoryValue = '';

          this.twoCategory = [];
          this.threeCategory = [];
        }
      },
    },
  },
  async mounted() {
    await this.querySupplierWhiteList();
    this.getOneCategoryValue();
  },
  methods: {
    //采购合同：0  、 附件：1    共同清单接口
    async ruleQueryList() {
      let params = {
        sceneType: 1,//场景类型 固定传1
        categoryCode: this.ruleForm.categoryCode,
      }
      const res = await productApi.ruleQueryList(params);
      if (res.code === '200') {

        //采购合同上传
        let contractList = res.data.filter((item) => item.attachmentType === '0');

        if (contractList.length > 0) {

          let attachmentMustData = contractList[0].reviewRuleList.filter((item) => Number(item.attachmentMust) === 1);
          if (attachmentMustData.length > 0) {
            this.rules.contractAttachList[0].required = true;
          } else {
            this.rules.contractAttachList[0].required = false;
          }
        } else {
          this.rules.contractAttachList[0].required = false;
        }

        //附件上传
        let attachmentList = res.data.filter((item) => item.attachmentType === '1');
        if (attachmentList.length > 0) {
          let attachmentMustData = attachmentList[0].reviewRuleList.filter((item) => Number(item.attachmentMust) === 1);
          if (attachmentMustData.length > 0) {
            this.rules.attachList[0].required = true;
          } else {
            this.rules.attachList[0].required = false;
          }
        } else {
          this.rules.attachList[0].required = false;
        }


      }
    },
    // 改变四级目录
    changeFourCategory(val, type) {
      const categoryData =
        this.fourCategory.filter((item) => item.categoryCode === val)[0] || {};

      const { categoryCode, isLeaf, categoryId } = categoryData;

      this.isLeaf = isLeaf;
      if (isLeaf === 1) {
        // this.ruleForm.lbbm = categoryCode;
        this.ruleForm.categoryId = categoryId;
        this.ruleForm.categoryCode = categoryCode;
        this.ruleQueryList();

        if (type === 'change' && this.$route.name != 'StockDetail') {
          this.ruleForm.attachList = [];
        }
        // this.ruleForm.attachList = [];
        // this.ruleForm.contractAttachList = [];
      }
    },
    // 改变三级目录
    changeThreeCategory(val, type) {
      const categoryData =
        this.threeCategory.filter((item) => item.categoryId === val)[0] || {};
      const { categoryCode, isLeaf, categoryId } = categoryData;

      this.isLeaf = isLeaf;
      if (isLeaf === 1) {
        // this.ruleForm.lbbm = categoryCode;
        this.ruleForm.categoryId = val;
        this.ruleForm.categoryCode = categoryCode;
        this.fourCategory = [];
        this.ruleQueryList();
      } else {
        this.fourCategory = [];
        // this.ruleForm.lbbm = '';
        this.ruleForm.categoryId = '';
        this.ruleForm.categoryCode = '';

        this.selectCompanyCategorys({
          categoryParentId: val,
          categoryLevel: 4,
          companyId: this.supplierCompanyId,
        }); // 获取四级类目
      }
      if (type === 'change' && this.$route.name != 'StockDetail') {
        this.ruleForm.attachList = [];
        this.ruleForm.contractAttachList = [];
      }
      // this.ruleForm.attachList = [];
      // this.ruleForm.contractAttachList = [];
    },
    // 改变二级类目,获取三级类目
    changeTwoCategory(val) {
      this.threeCategory = [];
      this.ruleForm.threeCategoryValue = '';
      this.fourCategory = [];
      // this.ruleForm.lbbm = '';
      this.ruleForm.categoryId = '';
      this.ruleForm.categoryCode = '';

      this.selectCompanyCategorys({
        categoryParentId: val,
        categoryLevel: 3,
        companyId: this.supplierCompanyId,
      }); // 获取三级类目
    },
    // 改变一级类目,获取二级类目
    changeOneCategory(val) {
      this.twoCategory = [];
      this.ruleForm.twoCategoryValue = '';
      this.threeCategory = [];
      this.ruleForm.threeCategoryValue = '';
      this.fourCategory = [];
      // this.ruleForm.lbbm = '';
      this.ruleForm.categoryId = '';
      this.ruleForm.categoryCode = '';

      this.selectCompanyCategorys({
        categoryParentId: val,
        categoryLevel: 2,
        companyId: this.supplierCompanyId,
      }); // 获取二级类目
    },
    // 获取一级类目
    getOneCategoryValue(val) {
      this.oneCategory = [];
      this.ruleForm.oneCategoryValue = '';
      this.twoCategory = [];
      this.ruleForm.twoCategoryValue = '';
      this.threeCategory = [];
      this.ruleForm.threeCategoryValue = '';
      this.fourCategory = [];
      // this.ruleForm.lbbm = '';
      this.ruleForm.categoryId = '';
      this.ruleForm.categoryCode = '';

      this.selectCompanyCategorys({
        categoryParentId: -1,
        categoryLevel: 1,
        companyId: val,
      }); // 获取一级类目
    },

    // 当前用户所在企业的供应商白名单 是否配置电仪
    async querySupplierWhiteList() {
      const res = await userApi.querySupplierWhiteList();

      if (res.code === '200') {
        if (res.data && res.data.major === '电仪') {
          this.handleDisable = true;
        }
      }
    },

    async selectCompanyCategorys(params) {
      // categoryParentId点一级分类的时候传-1，二三四级传前面选的categoryId
      const res = await productApi.selectCompanyCategorys(params);
      if (res.code === '200') {
        if (params.categoryParentId === -1) {
          // 获取一级类目
          this.oneCategory = res.data || [];
        } else if (params.categoryLevel === 2) {
          // 获取二级类目
          this.twoCategory = res.data || [];
        } else if (params.categoryLevel === 3) {
          // 获取三级类目
          this.threeCategory = res.data || [];
        } else if (params.categoryLevel === 4) {
          // 获取四级类目
          this.fourCategory = res.data || [];
        }
      }

      // //供应商白名单 配置电仪,品类前两级固定 编辑得时候不用带入固定值
      if (this.handleDisable && (this.disableFirstLevel || this.disableSecondLevel)) {
        if (process.env.NODE_ENV === 'production') {
          // 生产环境
          this.ruleForm.oneCategoryValue = 6984;
          this.ruleForm.twoCategoryValue = 7064;
        } else {
          // 测试环境
          this.ruleForm.oneCategoryValue = 2;
          this.ruleForm.twoCategoryValue = 316;
        }

        if (params.categoryParentId === -1) {
          this.changeOneCategory(this.ruleForm.oneCategoryValue);
          this.disableFirstLevel = false;
        } else if (params.categoryLevel === 2) {
          this.changeTwoCategory(this.ruleForm.twoCategoryValue);
          this.disableSecondLevel = false;
        }
      }
    },

    // 高亮显示
    showHighlight(val) {
      const arr = val.split('>');
      const endItem = arr[arr.length - 1];
      arr.pop();
      const str = arr.join('>');
      const endStr = endItem.replace(
        new RegExp(this.itemCategoryCode, 'g'),
        `<span style="color: #409EFF">${this.itemCategoryCode}</span>`
      );
      return `${str}>${endStr}`;
    },
    handleSelectChange(row) {
      if (row.routeList) {
        const nodeArr = row.routeList;
        this.tempData = nodeArr[nodeArr.length - 1];
        this.$set(this.tempData, 'categoryNameAl', row.labelName);
        this.tempNode = nodeArr[nodeArr.length - 1];

        this.selectCategoryList = [];
        this.itemCategoryCode = this.tempData.categoryName;

        this.ruleForm.categoryId = this.tempData.categoryId;
        this.ruleForm.categoryCode = this.tempData.categoryCode;

      } else {
        this.tempData.categoryNameAl = '';
        this.tempData.categoryLevel = 0;
      }
    },

    async queryCategoryRouteList(timer) {
      const res = await productApi.queryCategoryRouteList({
        categoryName: this.itemCategoryCode,
        dataFrom: this.dataFrom,
      });
      if (timer === this.timer) {
        if (res.code === '200') {
          this.categoryLoading = false;
          this.selectCategoryList = res.data;
          res.data.forEach((item) => {
            const arr = item.routeList.map((i) => i.categoryName);
            item.labelName = arr.join('>');
          });
        }
      } else {
        console.log('不是最后一次结果');
      }
    },
    handleRemoteMethod(name) {
      if (name !== '') {
        this.categoryLoading = true;
        this.itemCategoryCode = name;
        this.timer = new Date().getTime();
        this.queryCategoryRouteList(this.timer);
      } else {
        this.selectCategoryList = [];
      }
    },

    showCheckResult(requestId, aiCheckResult) {
      if (aiCheckResult === '审查不通过') {
        window.open(`${epecMallUrl}/intelligentReview?id=${requestId}`, '_blank');
      }
    },
    async selectCategoryRouteByCategoryId() {
      // 非详情，是电仪不查
      // if (!this.isDetail && this.handleDisable) {
      //   return false;
      // }

      const res = await productApi.selectCategoryRouteByCategoryId({
        categoryId: this.formData.categoryId,
      });

      if (res.code === '200' && res.data) {
        const {
          firstcategory,
          secondcategory,
          thirdcategory,
          fourthcategory,
          firstcategoryid,
          secondcategoryid,
          thirdcategoryid,
          fourthcategoryid,
          thirdcategorycode,
          fourthcategorycode,
        } = res.data;

        this.ruleForm.oneCategoryValue = firstcategoryid;
        this.changeOneCategory(firstcategoryid);
        this.ruleForm.twoCategoryValue = secondcategoryid;
        this.changeTwoCategory(secondcategoryid);
        this.ruleForm.threeCategoryValue = thirdcategoryid;
        this.changeThreeCategory(thirdcategoryid);

        // this.ruleForm.lbbm = this.formData.lbbm;
        if (fourthcategoryid) {
          this.ruleForm.categoryId = fourthcategoryid;
          this.ruleForm.categoryCode = fourthcategorycode;
        } else {
          this.ruleForm.categoryId = thirdcategoryid;
          this.ruleForm.categoryCode = thirdcategorycode;
        }

        this.ruleQueryList();

        const allCategoryValue = `${firstcategory}-${secondcategory}-${thirdcategory}`;
        const categoryNameAl = `${firstcategory}/${secondcategory}/${thirdcategory}`;
        if (fourthcategory) {
          this.allCategoryValue = `${allCategoryValue}-${fourthcategory}`;
          this.tempData.categoryNameAl = `${categoryNameAl}-${fourthcategory}`;
        } else {
          this.allCategoryValue = allCategoryValue;
          this.tempData.categoryNameAl = categoryNameAl;
        }
      }
    },
    // 采购合同上传数据
    dealContractAttachData(tableData) {
      this.ruleForm.contractAttachList = [];

      tableData.forEach((item) => {
        item.contractAttachList.forEach((attachItem) => {
          this.ruleForm.contractAttachList.push({ ...attachItem });
        });
      });

      if (this.isDetail) {
        this.handleUploadInDetail();
      }
    },
    // 进口原材料上传数据
    dealImportMaterialAttachData(tableData) {
      this.ruleForm.importedAttachList = [];

      tableData.forEach((item) => {
        item.importedAttachList.forEach((attachItem) => {
          this.ruleForm.importedAttachList.push({ ...attachItem });
        });
      });

      if (this.isDetail) {
        this.handleUploadInDetail();
      }
      // 触发表单验证
      this.$refs.commonUpload.validate();
    },
    // 采购合同上传
    handleContractFile(flag) {

      if (!this.ruleForm.categoryCode) {
        this.$message.warning('请先选择品类再上传附件。');
        return false;
      }

      this.handleFlag = flag;

      this.viewContractAttachData = [];
      if (this.ruleForm.contractAttachList.length > 0) {
        this.viewContractAttachData = this.ruleForm.contractAttachList;
      }

      this.contractUploadVisible = true;
    },
    // 进口原材料上传
    handleImportMaterial(flag) {
      this.handleFlag = flag;
      this.viewImportMaterialAttachData = [];
      if (this.ruleForm.importedAttachList.length > 0) {
        // 4:过程控制报告;5:原厂授权书;6:原始报关单
        const data1 = this.ruleForm.importedAttachList.filter(
          (item) => item.type === 4
        );
        const data2 = this.ruleForm.importedAttachList.filter(
          (item) => item.type === 5
        );
        const data3 = this.ruleForm.importedAttachList.filter(
          (item) => item.type === 6
        );
        this.viewImportMaterialAttachData.push({
          listName: '过程控制报告',
          importedAttachList: data1,
        });
        this.viewImportMaterialAttachData.push({
          listName: '原厂授权书（进口原材料、关键零部件）',
          importedAttachList: data2,
        });
        this.viewImportMaterialAttachData.push({
          listName: '原始报关单',
          importedAttachList: data3,
        });
      }
      this.importMaterialUploadVisible = true;
    },
    // 处理附件上传数据
    dealAttachmentFileData(tableData) {
      this.ruleForm.attachList = [];

      tableData.forEach((item) => {
        if (item.attachList.length > 0) {
          item.attachList.forEach((attachItem) => {
            this.ruleForm.attachList.push({...attachItem});
          });
        }
      });
      if (this.isDetail) {
        this.handleUploadInDetail();
      }
    },
    // 附件上传
    handleUpload(flag) {

      if (!this.ruleForm.categoryId) {
        this.$message.warning('请先选择品类再上传附件。');
        return false;
      }

      this.handleFlag = flag;

      this.viewTableData = [];
      if (this.ruleForm.attachList.length > 0) {
        this.viewTableData = this.ruleForm.attachList;
      }

      this.attachmentUploadVisible = true;
    },
    // 详情页支持上传文件
    async handleUploadInDetail() {
      // type为1，2时id为query，type为undefined时id为params
      // const { id: idQuery } = this.$route.query;
      const { id: idParams } = this.$route.params;
      const id =
        this.$route.query.type === '1' || this.$route.query.type === '2'
          ? this.formData.id
          : idParams;
      const params = {
        id,
        attachList: this.ruleForm.attachList,
        contractAttachList: this.ruleForm.contractAttachList,
        importedAttachList: this.ruleForm.importedAttachList,
      };
      // type==1？  ecMaterialSupplierModifyAttach  petroMaterialSupplierModifyAttach 库存单 modifyAttach
      console.log(this.$route.query, 'this.$route.query');
      let apiFn =
        this.$route.query.type === '1'
          ? api.ecMaterialSupplierModifyAttach
          : api.petroMaterialSupplierModifyAttach;
      // type为undefined是库存单
      if (this.$route.query.type === undefined) {
        apiFn = api.modifyAttach;
      }
      const res = await apiFn(params);
      if (res.code === '200') {
        this.$message.success('文件修改成功。');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.check-result {
  display: flex;
  align-items: center;
}
.color-red {
  color: #f0250f;
}
</style>
